import React, { useEffect, useState } from 'react'
import { Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { capitalize } from '../utils/capitalize'
import Link from './Link'
import Facebook from '../assets/images/social/Facebook.svg'
import Twitter from '../assets/images/social/Twitter.svg'
import Tiktok from '../assets/images/social/TikTok.svg'
import Youtube from '../assets/images/social/Youtube.svg'
import Instagram from '../assets/images/social/Instagram.svg'
import Linkedin from '../assets/images/social/LinkedIn.svg'

const iconFiles = { Facebook, Twitter, Tiktok, Youtube, Instagram, Linkedin }

const SocialIcons = ({ socialLinks }) => {
  const [isSafari, setIsSafari] = useState(false)

  useEffect(() => {
    const userAgent =
      // eslint-disable-next-line no-undef
      typeof window !== 'undefined' && navigator.userAgent.toLowerCase()
    if (userAgent.indexOf('safari') !== -1) {
      if (userAgent.indexOf('chrome') > -1) {
        setIsSafari(false)
      } else {
        setIsSafari(true)
      }
    }
  }, [])

  const styles = useStyles({ isSafari })

  return (
    <Box className={styles.socialIconsRoot}>
      {socialLinks?.map((social) => {
        const Icon = iconFiles[capitalize(social.title)]
        return (
          <Link
            id={`social-link-${social.title}`}
            key={`social-link-${social.title}`}
            isExternal={true}
            to={social.link}
            className={styles.socialIconButton}
          >
            <Icon className={styles.socialIcon} alt={`${social.title} icon`} />
          </Link>
        )
      })}
    </Box>
  )
}

export default SocialIcons

const useStyles = makeStyles((theme) => ({
  socialIconsRoot: {
    display: 'flex',
    justifyContent: 'center',
    [theme.breakpoints.up('mxl')]: {
      justifyContent: 'end',
    },
  },
  socialIconButton: {
    height: theme.spacing(5.25),
    width: theme.spacing(5.25),
    borderRadius: '50%',
    overflow: 'hidden',
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.footer.text,
    '&:not(:last-child)': {
      marginRight: theme.spacing(4),
    },
    '&>object, &>svg': {
      width: '75%',
    },
  },
  socialIcon: {
    width: '20px',
    transition: 'all 0.3s',
    filter: 'none',
  },
}))
